// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__OWJ3a","menuContent":"Menu_menuContent__JmeJr","language":"Menu_language__WlQuB","logo":"Menu_logo__RdkNs"};